"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.BUTTON_VARIANTS = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
exports.BUTTON_VARIANTS = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    tertiary: 'btn-tertiary',
    link: 'bg-transparent border-none text-link p-0 min-h-0 min-w-0',
    white: 'btn-white',
    dark: 'btn-dark',
};
var DEFAULT_ELEMENT = 'button';
exports.Button = react_1.default.forwardRef(function AOButton(_a, ref) {
    var _b = _a.as, ElementType = _b === void 0 ? DEFAULT_ELEMENT : _b, children = _a.children, className = _a.className, color = _a.color, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, disabled = _a.disabled, _d = _a.lg, lg = _d === void 0 ? false : _d, _e = _a.icon, icon = _e === void 0 ? false : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f, props = __rest(_a, ["as", "children", "className", "color", "variant", "disabled", "lg", "icon", "fullWidth"]);
    var isButtonElement = ElementType === 'button';
    var isLink = 'href' in props || 'to' in props;
    var buttonVariant = color || variant;
    return (react_1.default.createElement(ElementType
    // eslint-disable-next-line no-undefined
    , __assign({ 
        // eslint-disable-next-line no-undefined
        type: isButtonElement ? 'button' : undefined, disabled: isButtonElement && disabled, "aria-disabled": disabled, 
        // eslint-disable-next-line no-undefined
        role: !isLink && !isButtonElement ? 'button' : undefined, className: (0, classnames_1.default)('btn', icon && 'btn-icon', fullWidth && 'w-full justify-center', lg && 'btn-lg', disabled ? 'btn-inactive' : exports.BUTTON_VARIANTS[buttonVariant], className), "data-aods": "button" }, props, { ref: ref }), children));
});
exports.default = exports.Button;
//# sourceMappingURL=Button.js.map